import { render, staticRenderFns } from "./miaojiaStation.vue?vue&type=template&id=af4eedce&scoped=true&"
import script from "./miaojiaStation.vue?vue&type=script&lang=js&"
export * from "./miaojiaStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4eedce",
  null
  
)

export default component.exports